import { useEffect } from "react";

const DEFAULTS = {
  title: "CARDED | Fast Loan Solutions Made Simple",
  description:
    "CARDED is a trusted Loan DSA in India offering Personal, Business, Home Loans, LAP, Working Capital & Credit Card assistance through multiple Banks and NBFCs.",
};

const setMeta = (name, content, attr = "name") => {
  if (!content) return;
  let el = document.querySelector(`meta[${attr}="${name}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, name);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

export const Seo = ({ title, description }) => {
  useEffect(() => {
    const t = title || DEFAULTS.title;
    const d = description || DEFAULTS.description;
    document.title = t;
    setMeta("description", d);
    setMeta("og:title", t, "property");
    setMeta("og:description", d, "property");
    setMeta("twitter:title", t);
    setMeta("twitter:description", d);
  }, [title, description]);
  return null;
};

export default Seo;
